// src/helpers/roles.js

export const Roles = {
  None: 0,
  Management: 1,
  Finance: 2,
  Support: 4,
  WealthManager: 16,
  Fiduciary: 32,
  BackOffice: 64,
  ClientServices: 128,
  SubscriptionAdmin: 512,
  EndClient: 2048,
  LibraryAdmin: 16777216,
  Compliance: 33554432,
  Designer: 67108864,
  SystemAdmin: 536870912,
  ClientExperience: 1073741824
};

/**
 * Checks if a user has a specific role
 * @param {number} userRole - role value from redux (bitwise combined)
 * @param {number} requiredRole - role from Roles enum
 * @returns {boolean}
 */
export const hasAccess = (userRole, requiredRole) => {
  if (!userRole || !requiredRole) return false;

  return (userRole & requiredRole) === requiredRole;
};
